module.exports = __webpack_public_path__ + "static/banner-servicios-4897adc31c6bab27a163fe1f90f8ec40.jpg";